import { createContext, type ReactNode } from 'react';

export const ProjectPickerAcceptedContext = createContext<(() => void) | null>(null);

export interface ProjectPickerDetails {
  projectName: string;
  projectLabel?: ReactNode;
  content: ReactNode;
  returnFocus: () => void;
}
export const ProjectPickerDetailsContext = createContext<
  ((details: ProjectPickerDetails) => void) | null
>(null);

/** Both panes need their full width plus the outer gutter and gap. */
export function hasRoomForProjectDetails(left: number, right: number, viewportWidth: number) {
  return left >= 448 || viewportWidth - right >= 448;
}
